import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { acceptInviteAuthenticated } from '@/api/invites.api';
import { useRefreshSession } from './useRefreshSession';
import { ROUTES } from '@/lib/constants/routes';

/**
 * Login-based invite-accept mutation (no OTP) - only used when
 * `InvitePreview.acceptMethod === 'login'`. On success, refreshes the
 * session before navigating: the newly-created membership must be baked
 * into a fresh JWT before entity-scoped routes/guards admit the user - the
 * same reason `StartupCreatedPage.tsx` refreshes the session after creating
 * a startup entity.
 */
export function useAcceptInviteAuthenticated(token: string) {
  const navigate = useNavigate();
  const refreshSession = useRefreshSession();

  return useMutation({
    mutationFn: () => acceptInviteAuthenticated(token),
    onSuccess: async (result) => {
      await refreshSession.mutateAsync();
      // A startup admin invite has no team to show yet: its next step is
      // creating the startup (MYN-311).
      navigate(result.nextStep === 'create_startup' ? ROUTES.CREATE_STARTUP : ROUTES.DASHBOARD);
    },
  });
}
